import { ACtaTextMixin } from '../utils/mixins/_a-cta-text';

class ACtaTextAnchor extends ACtaTextMixin(HTMLAnchorElement) {}

customElements.define('a-cta-text-anchor', ACtaTextAnchor, { extends: 'a' });
